import React, { useEffect } from 'react';
import { logSentryError } from '@/lib/sentry';
import * as Sentry from '@sentry/react';

/**
 * Sentry 에러 테스트 컴포넌트
 * 다양한 방식으로 에러를 발생시켜 Sentry 작동을 테스트합니다.
 */
const SentryTest: React.FC = () => {
  // 컴포넌트 마운트 시 Sentry 초기화 상태 확인
  useEffect(() => {
    console.log('Sentry 초기화 상태:', Sentry);
    
    // 테스트 이벤트 발송
    Sentry.captureMessage("테스트 메시지 - 컴포넌트 로드됨", "info");
    console.log("테스트 메시지를 Sentry로 전송했습니다.");
  }, []);

  // 일반적인 JavaScript 에러 발생시키기
  const handleUncaughtError = () => {
    console.log("처리되지 않는 에러 발생 시도");
    throw new Error("This is your first error!");
  };

  // Sentry API를 통해 직접 에러 로깅하기
  const handleCaughtError = () => {
    console.log("처리된 에러 발생 시도");
    try {
      // 의도적으로 존재하지 않는 메서드 호출
      const nonExistentArray: any = null;
      nonExistentArray.forEach((item: any) => console.log(item));
    } catch (error) {
      console.log("에러가 발생하여 Sentry로 전송합니다:", error);
      // 에러를 잡아서 Sentry에 수동으로 전송
      logSentryError(error instanceof Error ? error : new Error(String(error)), {
        context: 'SentryTest 컴포넌트',
        method: 'handleCaughtError'
      });
      alert('에러가 발생했지만 처리되었습니다. Sentry에 기록되었습니다.');
    }
  };

  // 인라인 에러 테스트
  const handleBreakTheWorld = () => {
    console.log("Break the world 버튼 클릭됨");
    throw new Error("This is your first error from Break the world!");
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md">
      <h2 className="text-lg font-bold mb-4">Sentry 테스트</h2>
      <div className="space-y-4">
        <div>
          <p className="text-sm text-gray-600 mb-2">
            처리되지 않는 에러 발생 (앱이 중단됨)
          </p>
          <button
            onClick={handleUncaughtError}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            처리되지 않는 에러 발생
          </button>
        </div>

        <div>
          <p className="text-sm text-gray-600 mb-2">
            처리된 에러 발생 (앱이 계속 실행됨)
          </p>
          <button
            onClick={handleCaughtError}
            className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
          >
            처리된 에러 발생
          </button>
        </div>

        <div>
          <p className="text-sm text-gray-600 mb-2">
            인라인 에러 발생 (공식 문서 예제)
          </p>
          <button
            onClick={handleBreakTheWorld}
            className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600"
          >
            Break the world
          </button>
        </div>
      </div>
    </div>
  );
};

export default SentryTest; 